import styled, { css } from 'styled-components';

export const Description = styled.p`
 ${({ theme }) => css`
    color: ${theme.v2.colors.brand.primaryBlue};
    font-family: ${theme.v2.font.family.primary};
    font-size: 28px;
    font-weight: ${theme.v2.font.weights.bold};
    line-height: 140%;
    margin: 0px 0px 20px 0px;

    span {
      color: ${theme.v2.colors.brand.primaryExtraDark};
    }

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      font-size: ${theme.v2.font.sizes.sm2};
    }
  `}
`;

export const DescriptionList = styled.ul`
  ${({ theme }) => css`
    color: ${theme.v2.colors.brand.primaryExtraDark};
    margin: 0;
    padding: 0;
    list-style: none;
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-bottom: 24px;
  `}
`;

export const DescriptionListItem = styled.li`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    gap: 8px;
    margin: 0;
    padding: 0;
    color: ${theme.v2.colors.neutral.lowPure};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: 140%;
    list-style: none;
    text-align: left;
    svg {
      width: 20px;
      height: 20px;
    }
  `}
`;
